module.exports = __webpack_public_path__ + "img/Foggs-Christmas-Adventure.de5ba74c.jpg";